import classNames from 'classnames';
import React from 'react';
import { IconSpan } from '../../../../../components/IconSpan';
import { Size } from '../../../../../utils/types/Size';
import { Button } from 'reactstrap';
import styles from './styles.module.scss';
import {
  sizeSmallerThan,
  useScreenSize,
} from '../../../../../utils/useScreenSize';

interface PropTypes {
  color: string;
  size: Size;
  previewMode?: boolean;
  hidden?: boolean;
  className?: string;
  text?: string;
  isResponsive?: boolean;
  onClick: () => void;
}

export function BackToCareersPageButton(props: PropTypes) {
  const previewMode = props.previewMode ?? false;
  let smallerScreen = false;

  if (props.isResponsive) {
    smallerScreen = sizeSmallerThan(useScreenSize(), 'sm');
  }

  return (
    <Button
      color={props.color}
      size={props.size}
      className={classNames(props.className, {
        invisible: props.hidden,
        'py-0': props.hidden,
        'w-100': smallerScreen,
        [styles['invisible-button']]: props.hidden,
      })}
      type={'button'}
      disabled={previewMode}
      onClick={props.onClick}
    >
      <IconSpan
        spanText={props.text ?? 'Back to Job Openings'}
        icon={{ name: 'bi-arrow-left' }}
        position={'start'}
        className={classNames(smallerScreen && 'justify-content-center')}
      />
    </Button>
  );
}
